/**
 * Canonical list-gesture tip copy for ListSurfaceStatusBar (?).
 * Do not repeat this string as per-widget footer chrome.
 */
export const LIST_GESTURE_TIPS =
  'Click to select · ⌘/Ctrl+click new tab · Right-click for menu · Double-click open'

/** Surfaces with PanelRight preview pin (Home, Inbox folders, Search activity, gallery). */
export const LIST_GESTURE_TIPS_WITH_PREVIEW = `${LIST_GESTURE_TIPS} · PanelRight pins preview`

/** Search footer (?) - syntax help, not a monospaced hint under the query field. */
export const SEARCH_SYNTAX_TIPS =
  'Keyword search. Operators: file:name.md  path:docs/  tag:bet  project:gg'

/** Drive folder view (main panel). Click selects; double-click opens files / enters folders. */
export const LIST_GESTURE_TIPS_DRIVE =
  'Click to select · Right-click for menu · Double-click open · Files + folders in main'

export const LIST_GESTURE_TIPS_DRIVE_WITH_PREVIEW =
  `${LIST_GESTURE_TIPS_DRIVE} · PanelRight pins preview`

/** Product Board kanban - DocumentContentStatusBar (i) and standalone ListSurfaceStatusBar (?). */
export const LIST_GESTURE_TIPS_PRODUCT_BOARD =
  'Drag card to chat · Drag handle to reorder · Cmd+Z undo · Cmd+Shift+Z redo'
